import { render } from "./App.vue?vue&type=template&id=6797bd97&bindings={}"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&lang=less"
import "./App.vue?vue&type=style&index=1&lang=scss"
script.render = render

export default script